import { t } from '@lingui/core/macro';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';

export function FieldPartType({
    onChange,
    ...props
}: Omit<FieldSelectProps<string>, 'onChange'> & { onChange: (partType: string) => void }): JSX.Element {
    return (
        <FieldSelect
            disabled={props.options.length === 0}
            getOptionLabel={(x) => x}
            placeholder={t`Part type`}
            disableClearable
            onChange={(partType) => onChange(partType ?? props.options[0])}
            {...props}
        />
    );
}
